import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaWhatsapp } from 'react-icons/fa';
import styles from './pagina_tatienelibrelon.module.scss';
import { getWhatsappUrl } from './dados_tatienelibrelon.ts';

type Atendimento = {
    grupo: string;
    titulo: string;
    subtitulo?: string;
    texto: string;
};

const ATENDIMENTOS: Atendimento[] = [
    {
        grupo: 'Online',
        titulo: 'Consulta online para fertilidade',
        subtitulo: 'Agende de onde você estiver',
        texto: 'Consulta online individualizada para orientar e acompanhar a sua jornada na fertilidade, com cuidado e atenção às suas necessidades.',
    },
    {
        grupo: 'Online',
        titulo: 'Atendimento online de acupuntura',
        subtitulo: 'Orientação e cuidado onde você estiver',
        texto: 'Atendimento online individualizado, com orientações e acompanhamento conforme a sua necessidade. Para quem deseja receber orientações sobre práticas complementares de autocuidado e, quando indicado, aprender a utilizar estímulos não invasivos. O formato e as técnicas são definidos conforme cada caso.',
    },
    {
        grupo: 'Gestantes',
        titulo: 'Acupuntura para gestantes',
        texto: 'Um cuidado complementar individualizado para promover relaxamento e bem-estar durante a gravidez. A escolha dos pontos e das técnicas considera a fase gestacional, as queixas e as condições de saúde da gestante. O atendimento é realizado com avaliação criteriosa e atenção às orientações do obstetra.',
    },
    {
        grupo: 'Gestantes',
        titulo: 'Momento de autocuidado para gestantes',
        texto: 'Um atendimento pensado para acolher a futura mamãe, oferecendo uma pausa na rotina para cuidar do corpo e das emoções. As técnicas são escolhidas de acordo com as necessidades individuais, priorizando conforto, segurança e tranquilidade durante essa fase tão especial.',
    },
];

const Atendimentoonline_tatienelibrelon: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    let grupoAtual = '';

    return (
        <div className={styles.pagina_tatienelibrelon} lang="pt-BR">
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/tatienelibrelon" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <p className={styles.eyebrow}>Onde você estiver</p>
                <h1 className={styles.title}>Atendimento online</h1>
                <p className={styles.lead}>Orientação e cuidado para o seu momento, com acompanhamento individualizado.</p>

                {ATENDIMENTOS.map((item) => {
                    const mostrarGrupo = item.grupo !== grupoAtual;
                    grupoAtual = item.grupo;

                    return (
                        <React.Fragment key={item.titulo}>
                            {mostrarGrupo ? <h2 className={styles.groupTitle}>{item.grupo}</h2> : null}
                            <article className={styles.card}>
                                <div className={styles.cardBody}>
                                    <h3 className={styles.cardTitle}>{item.titulo}</h3>
                                    {item.subtitulo ? (
                                        <p className={styles.cardSubtitle}>{item.subtitulo}</p>
                                    ) : null}
                                    <p className={styles.cardText}>{item.texto}</p>
                                    <a
                                        href={getWhatsappUrl(
                                            `Olá, Tatiene! Vim pelo Instagram e gostaria de saber mais sobre ${item.titulo}.`
                                        )}
                                        className={styles.cardBtn}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaWhatsapp aria-hidden />
                                        Agendar
                                    </a>
                                </div>
                            </article>
                        </React.Fragment>
                    );
                })}

                <div className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Precisa de ajuda?</h2>
                    <p className={styles.paragraph}>Entre em contato e tire suas dúvidas.</p>
                    <a
                        href={getWhatsappUrl(
                            'Olá, Tatiene! Vim pelo Instagram e gostaria de saber mais sobre o atendimento online.'
                        )}
                        className={styles.ctaBtn}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaWhatsapp aria-hidden />
                        Falar no WhatsApp
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Atendimentoonline_tatienelibrelon;
